import React, { useEffect, useRef } from "react";
import { useTheme } from "@mui/material/styles";
import "../styles/tabbedLanding.css";

import Hero from "./landing/Hero";
import Platform from "./landing/Platform";
import Compare from "./landing/Compare";
import BlazeAISection from "./landing/BlazeAISection";
import CTA from "./landing/CTA";
import MarketingInfoBar from "./MarketingInfoBar";
import PageMeta from "./PageMeta";
import { initReveal } from "./landing/helpers";

export default function LandingPage() {
  const theme = useTheme();
  const rootRef = useRef(null);
  const dataTheme = theme.palette.mode === "dark" ? "dark" : "light";

  useEffect(() => {
    if (!rootRef.current) return undefined;
    return initReveal(rootRef.current);
  }, []);

  return (
    <main
      ref={rootRef}
      className="ib-tabbed"
      data-theme={dataTheme}
      data-density="comfortable"
      data-motion="on"
    >
      <PageMeta
        title="InfraBlaze — Control Plane for Agent Driven Infrastructure"
        description="InfraBlaze is the control plane for agent-driven infrastructure. Design, cost, review, enforce and verify cloud infra across AWS, Azure, and GCP — one workbench for IaC, policy, and drift."
        keywords="control plane, agent driven infrastructure, AI infrastructure, cloud control plane, InfraBlaze, IaC, Terraform, multi-cloud, policy as code, drift detection, AWS, Azure, GCP"
      />
      <Hero />
      <Platform />
      <Compare />
      <BlazeAISection />
      <CTA />
      <MarketingInfoBar />
    </main>
  );
}
